<template lang="pug">
#editar-relatorio-rastreabilidade
    BaseHeader#editar-relatorio-rastreabilidade-header(
        :titulo='$t("mensagens.relatorioRastreabilidade.editar.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        .bloco-dados-relatorio
            BlocoInserirDadosRelatorio(
                v-if='dadosParaRelatorioRastreabilidadeEdicao',
                @dadosRelatorio='dadosIniciaisRelatorio',
                @handleValidationFailed='handleValidationFailed',
                :bloquearEdicao='bloquearEdicao',
                :dadosEdicao='dadosParaRelatorioRastreabilidadeEdicao',
                ref='dadosIniciaisRelatorio'
            )

        .bloco-protocolo-relatorio
            BlocoProtocolosAnaliseRelatorio(
                v-if='dadosParaRelatorioRastreabilidadeEdicao',
                @protocoloSelecionado='protocoloSelecionado',
                @handleValidationFailed='handleValidationFailed',
                :bloquearEdicao='bloquearEdicao',
                :dadosEdicao='dadosParaRelatorioRastreabilidadeEdicao',
                ref='protocolo'
            )

        .bloco-consulta-analise-rastreabilidade
            BlocoInserirDadosAnaliseRastreabilidade(
                @adicionarTerritorioRelatorioListagem='adicionarTerritorioRelatorioListagem',
                @validarAdicionarListagem='validarAdicionarListagem',
                @validarCamposDadosRelatorio='validarDadosRelatorioResumo',
                @handleValidationFailed='handleValidationFailed',
                @capacidadeProdutiva='capacidadeProdutivaTerritorio',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                :dados='dados',
                ref='analiseRastreabilidade'
            )

        .bloco-preenchimento-em-lote
            BlocoInserirDadosRastreabilidadePlanilha(
                :dados='dadosParaRelatorioRastreabilidade',
                @validarCamposDadosRelatorioLote='validarCamposDadosRelatorioLote',
                @adicionarListagemLote='adicionarListagemLote',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                ref='editarPlanilhaLote'
            )

        .bloco-novos-relatorios-tabela
            TabelaNaoEnviadosRelatorioRastreabilidade(
                @removerTerritorioLote='removerTerritorioLote',
                @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidade',
                @volumeTotalAdicionado='volumeTotalTerritorios',
                @bloqueioDeEdicao='bloqueioDeEdicao',
                :carregando='carregandoDadosEdicao',
                :relatoriosNaoEnviados='relatoriosNaoEnviados',
                :removendo='removendoTerritoriosRelatorio',
                :volumeContrato='dadosParaRelatorioRastreabilidade.volumeContrato',
                ref='tabelaTerritorio'
            )

        ModalAnaliseElegibilidadeRelatorio(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false',
            :idMapa='"mapaAnaliseEleigibilidadeRelatorioVisualizar"'
        )

        footer
            .botao-relatorio__remover
                el-button(
                    v-if='removendoTerritoriosRelatorio',
                    @click.native='removendoTerritoriosRelatorio = false'
                ) {{ this.$t('mensagens.comuns.cancelar') }}

                el-button(
                    v-if='!removendoTerritoriosRelatorio',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoTerritoriosRelatorio = true'
                ) {{ this.$t('mensagens.comuns.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerRelatorio'
                ) {{ this.$t('mensagens.comuns.confirmarRemocao') }}

            .botao-relatorio__salvar
                el-button#adicionar-analise(
                    type='primary',
                    icon='mdi mdi-content-save-outline',
                    @click.native='validarCamposInserirRelatorio',
                    :disabled='loadingAtualizarContrato'
                ) {{ this.$t('mensagens.comuns.atualizar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInserirDadosRelatorio from '@/components/relatorioRastreabilidade/BlocoInserirDadosRelatorio.vue';
import BlocoProtocolosAnaliseRelatorio from '@/components/relatorioRastreabilidade/BlocoProtocolosAnaliseRelatorio.vue';
import BlocoInserirDadosAnaliseRastreabilidade from '@/components/relatorioRastreabilidade/BlocoInserirDadosAnaliseRastreabilidade.vue';
import BlocoInserirDadosRastreabilidadePlanilha from '@/components/relatorioRastreabilidade/BlocoInserirDadosRastreabilidadePlanilha.vue';
import TabelaNaoEnviadosRelatorioRastreabilidade from '@/components/relatorioRastreabilidade/TabelaNaoEnviadosRelatorioRastreabilidade.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import ModalAnaliseElegibilidadeRelatorio from '@/components/relatorioRastreabilidade/ModalAnaliseElegibilidadeRelatorio.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import MunicipioService from '@/services/MunicipioService';

export default {
    name: 'EditarRelatorio',
    props: ['idRelatorio'],
    components: {
        BaseHeader,
        BlocoInserirDadosRelatorio,
        BlocoProtocolosAnaliseRelatorio,
        BlocoInserirDadosAnaliseRastreabilidade,
        BlocoInserirDadosRastreabilidadePlanilha,
        TabelaNaoEnviadosRelatorioRastreabilidade,
        ModalAnaliseElegibilidadeRelatorio
    },
    data() {
        return {
            removendoTerritoriosRelatorio: false,
            dados: {},
            dadosParaRelatorioRastreabilidade: {
                id: null,
                numeroContrato: '',
                nomeCultura: '',
                volumeContrato: null,
                idProtocolo: '',
                detalheInput: []
            },
            dadosParaRelatorioRastreabilidadeEdicao: null,
            relatoriosNaoEnviados: [],
            carregandoDadosEdicao: false,
            territoriosSelecionados: [],
            validationFailed: false,
            volumeValidationFailed: false,
            ativarModalAnaliseElegibilidade: false,
            volumeTotalAdicionado: '',
            capacidadeProdutiva: '',
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                cpfCnpj: '',
                safraNome: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: ''
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: ''
                }
            },
            loadingAtualizarContrato: false,
            volumeTotalAdicionadoConvertido: '',
            bloquearEdicao: true
        };
    },
    mounted() {
        this.buscarRelatorio();
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.buscarRelatorio();
        }
    },

    methods: {
        async buscarRelatorio() {
            if (!this.idRelatorio) {
                this.$router.push({ name: 'RelatorioRastreabilidade' });
                return;
            }
            this.carregandoDadosEdicao = true;
            try {
                const result =
                    await RelatorioRastreabilidadeService.buscarRelatorioIndividual(
                        this.idRelatorio
                    );

                this.preencherDadosParaEdicao(result.data.item);
            } catch (error) {}
            this.carregandoDadosEdicao = false;
        },
        preencherDadosParaEdicao(dadosEdicao) {
            this.dadosParaRelatorioRastreabilidadeEdicao = {
                numeroContrato: Number(dadosEdicao.numeroContrato),
                nomeCultura: dadosEdicao.culturaCodigo,
                volumeContrato: dadosEdicao.volumeContrato
                    .toString()
                    .replace('.', ',')
            };
            this.dadosIniciaisRelatorio(
                this.dadosParaRelatorioRastreabilidadeEdicao
            );
            this.dadosParaRelatorioRastreabilidadeEdicao.idProtocolo =
                dadosEdicao.idProtocolo;

            if (dadosEdicao.detalhamento.length) {
                dadosEdicao.detalhamento.forEach(item => {
                    if (
                        !this.relatoriosNaoEnviados.some(
                            relatorio => relatorio.id === item.id
                        )
                    ) {
                        this.relatoriosNaoEnviados.push({
                            id: item.id,
                            anoSafra: item.anoSafra,
                            codigoCar: item.territorio.nome,
                            cpfCnpj: item.cpfCnpj,
                            dataAnalise: item.dataAnalise,
                            idLinha: Math.floor(Math.random() * 1000000),
                            nivelAlerta:
                                item.resultadoDiagnostico
                                    .nivelAlertaRastreabilidade,
                            resultadoDiagnostico: JSON.stringify(
                                item.resultadoDiagnostico
                            ),
                            situacao: item.situacao,
                            volumeAdicionado: item.volumeAdicionado
                        });
                    }
                });
            }
            this.dadosParaRelatorioRastreabilidade.id = dadosEdicao.id;
            this.dadosParaRelatorioRastreabilidade.idProtocolo =
                dadosEdicao.idProtocolo;
            this.dadosParaRelatorioRastreabilidade.detalheInput =
                this.relatoriosNaoEnviados;
        },
        dadosIniciaisRelatorio(dadosRelatorio) {
            this.dados = dadosRelatorio;

            this.dadosParaRelatorioRastreabilidade.numeroContrato =
                dadosRelatorio.numeroContrato;
            this.dadosParaRelatorioRastreabilidade.nomeCultura =
                dadosRelatorio.nomeCultura;
            this.dadosParaRelatorioRastreabilidade.volumeContrato = parseFloat(
                dadosRelatorio.volumeContrato.replace(',', '.')
            );
        },

        protocoloSelecionado(idProtocoloSelecionado) {
            this.dadosParaRelatorioRastreabilidade.idProtocolo =
                idProtocoloSelecionado;
        },

        bloqueioDeEdicao(valor) {
            if (!valor) {
                if (!this.relatoriosNaoEnviados.length) {
                    this.bloquearEdicao = false;
                }
            } else {
                this.bloquearEdicao = valor;
            }
        },

        adicionarTerritorioRelatorioListagem(dadosRelatorioDiagnostico) {
            if (!this.bloquearEdicao) {
                this.bloquearEdicao = true;
            }

            this.dadosParaRelatorioRastreabilidade.detalheInput.push(
                dadosRelatorioDiagnostico
            );
            this.relatoriosNaoEnviados =
                this.dadosParaRelatorioRastreabilidade.detalheInput;
        },

        validarDadosRelatorioResumo(volumeTerritorio) {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.$refs.analiseRastreabilidade.validarRealizarResumo();
            }
        },

        handleValidationFailed() {
            this.validationFailed = true;
        },

        validarCamposInserirRelatorio() {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.atualizarRelatorioRastreabilidade();
            }
        },

        somaVolumeTerritoriosInseridos(territorios) {
            let somaVolumes = 0;

            for (let i = 0; i < territorios.length; i++) {
                if (territorios[i].volumeAdicionado) {
                    somaVolumes += territorios[i].volumeAdicionado;
                }
            }
            return (
                somaVolumes >
                this.dadosParaRelatorioRastreabilidade.volumeContrato
            );
        },

        async atualizarRelatorioRastreabilidade() {
            if (this.loadingAtualizarContrato) {
                return;
            }
            if (!this.dadosParaRelatorioRastreabilidade.detalheInput.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.necessarioInserirAoMenosUmTerritorio'
                    )
                });
                return;
            }

            if (
                this.dadosParaRelatorioRastreabilidade.detalheInput.some(
                    item => item.situacao === 'INCONFORME'
                ) ||
                this.dadosParaRelatorioRastreabilidade.detalheInput.some(
                    item => item.situacao === 'ALERTA'
                )
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.necessarioRemoverTerritorios'
                    )
                });
                return;
            }

            if (
                this.somaVolumeTerritoriosInseridos(
                    this.dadosParaRelatorioRastreabilidade.detalheInput
                )
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeAlterado'
                    )
                });
                return;
            }

            this.loadingAtualizarContrato = true;
            try {
                await RelatorioRastreabilidadeService.atualizarRelatorios(
                    this.dadosParaRelatorioRastreabilidade
                );

                this.loadingAtualizarContrato = false;

                this.$notify.success(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.relatorioAtualizadoSucesso'
                    )
                );
                this.$router.push({ name: 'RelatorioRastreabilidade' });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
            this.loadingAtualizarContrato = false;
        },

        removerTerritorioLote(idsTerritorios) {
            this.territoriosSelecionados = idsTerritorios;
        },

        async removerRelatorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.naoHaTerritoriosSelecionadoParaRemocao'
                    )
                );
            } else {
                this.$nextTick(() => {
                    this.$refs.tabelaTerritorio.removerTerritorio(
                        this.territoriosSelecionados
                    );

                    this.$refs.analiseRastreabilidade.limparTerritorios();
                    this.$refs.editarPlanilhaLote.resetarElegibilidade();
                });
            }
        },

        visualizarAnaliseElegibilidade(row) {
            if (!row?.dadosAnaliseElegibilidade) {
                this.realizarAnaliseElegibilidade(row);
            } else {
                this.dadosAnaliseElegibilidade = row.dadosAnaliseElegibilidade;
                this.ativarModalAnaliseElegibilidade = true;
            }
        },

        async realizarAnaliseElegibilidade(row) {
            this.limparDadosResumo();
            this.dadosAnaliseElegibilidade.dadosDiagnostico = JSON.parse(
                row.resultadoDiagnostico
            );

            this.dadosAnaliseElegibilidade.safraNome = row.anoSafra;

            this.buscarSaldo(row);
            this.analisarElegibilidade();
        },

        async buscarSaldo(row) {
            const dados = {
                codigoCar: row.codigoCar,
                nomeMaterial:
                    this.dadosParaRelatorioRastreabilidade.nomeCultura,
                anoSafra: row.anoSafra,
                numeroContrato:
                    this.dadosParaRelatorioRastreabilidade.numeroContrato,
                idTerritorio: 0
            };

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.buscarSaldo(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;

                this.analisarElegibilidade();
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async calcularRaio(row) {
            const dados = {
                idTerritorio: '',
                numeroCar: row.codigoCar,
                numeroContrato:
                    this.dadosParaRelatorioRastreabilidade.numeroContrato
            };

            try {
                const response =
                    await MunicipioService.ValidarMunicipioRaioAceiteCar(dados);
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = response.data;

                this.analisarElegibilidade();
            } catch (error) {
                if (
                    error.response.data.message ===
                    'O número do CAR informado não foi encontrado na vega API.'
                ) {
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
        },

        analisarElegibilidade() {
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === null
            ) {
                return;
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva === null
            ) {
                return;
            }
            let resultadoElegibilidade = 'INDEFINIDO';
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === 'INCONFORME'
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            } else if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .nivelAlertaRastreabilidade === 'MEDIO_ALTO'
            ) {
                resultadoElegibilidade = 'ALERTA';
            } else {
                resultadoElegibilidade = 'ELEGIVEL';
            }

            if (
                this.dadosAnaliseElegibilidade.dadosCalculoRaio
                    .distanciaRaioMunicipioECar > this.limiteRaio
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva <= 0
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            this.dadosAnaliseElegibilidade.elegibilidade =
                resultadoElegibilidade;

            this.ativarModalAnaliseElegibilidade = true;
        },

        limparDadosResumo() {
            this.dadosAnaliseElegibilidade = {
                valor: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                },
                carregandoBuscarCpfCnpj: false
            };
        },

        validarAdicionarListagem(volumeTerritorio, car) {
            this.validationFailed = false;

            this.$refs.analiseRastreabilidade.validateForm();
            this.$refs.analiseRastreabilidade.validateFormVolume();

            if (this.carExisteNaListagem(car)) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.carInformadoJaInseridoListagem'
                    )
                });
                return;
            }

            this.validaVolumeDisponivel(volumeTerritorio);

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else if (this.volumeValidationFailed) {
            } else {
                this.$refs.analiseRastreabilidade.adicionarTerritorioListagem();
            }
        },

        carExisteNaListagem(car) {
            return this.relatoriosNaoEnviados.some(
                territorio => territorio.codigoCar === car
            );
        },

        carExisteNaListagemLote(dadosRelatorioDiagnosticoPlanilha) {
            return dadosRelatorioDiagnosticoPlanilha.some(item => {
                return this.relatoriosNaoEnviados.some(
                    relatorio => relatorio.codigoCar === item.codigoCar
                );
            });
        },

        volumeTotalTerritorios(volumeTotalAdicionado) {
            this.volumeTotalAdicionadoConvertido = parseFloat(
                volumeTotalAdicionado.replace(',', '.')
            );
        },

        capacidadeProdutivaTerritorio(capacidadeProdutiva) {
            this.capacidadeProdutiva = capacidadeProdutiva;
        },

        validarCamposDadosRelatorioLote() {
            this.validationFailed = false;

            this.$refs.dadosIniciaisRelatorio.validateForm();
            this.$refs.protocolo.validateForm();

            if (this.validationFailed) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPrecisamEstarPreenchidosCorretamente'
                    )
                );
            } else {
                this.$refs.editarPlanilhaLote.$refs.uploadPlanilhaTerritorio.$el
                    .querySelector('.el-upload__input')
                    .click();
            }
        },

        adicionarListagemLote(dadosRelatorioDiagnosticoPlanilha, volume) {
            if (
                volume >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato ||
                volume + this.volumeTotalAdicionadoConvertido >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeExcedeVolumeContrato'
                    )
                });
                this.volumeValidationFailed = true;
                return;
            }

            if (
                this.carExisteNaListagemLote(dadosRelatorioDiagnosticoPlanilha)
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.carJaInseridoListagem'
                    )
                });
                return;
            }

            if (!this.bloquearEdicao) {
                this.bloquearEdicao = true;
            }

            this.dadosParaRelatorioRastreabilidade.detalheInput.push(
                ...dadosRelatorioDiagnosticoPlanilha
            );
            this.relatoriosNaoEnviados =
                this.dadosParaRelatorioRastreabilidade.detalheInput;

            this.$refs.editarPlanilhaLote.limparDadosPlanilha();
        },

        validaVolumeDisponivel(volumeTerritorio) {
            const volumeTerritorioNumero = parseFloat(
                volumeTerritorio.replace(',', '.')
            );

            this.volumeValidationFailed = false;
            if (volumeTerritorioNumero > this.capacidadeProdutiva) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeExcedeCapacidadeProdutiva'
                    )
                });
                this.volumeValidationFailed = true;
                return;
            }

            if (
                volumeTerritorioNumero >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato &&
                volumeTerritorioNumero + this.volumeTotalAdicionadoConvertido >
                    this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeExcedeVolumeContrato'
                    )
                });
                this.volumeValidationFailed = true;
                return;
            }

            if (
                volumeTerritorioNumero + this.volumeTotalAdicionadoConvertido >
                this.dadosParaRelatorioRastreabilidade.volumeContrato
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volumeExcedeVolumeDisponivelContrato'
                    )
                });
                this.volumeValidationFailed = true;
            }
        }
    }
};
</script>

<style lang="scss">
#editar-relatorio-rastreabilidade {
    .secao-listagem {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .secao-listagem,
    .bloco-dados-relatorio,
    .bloco-protocolo-relatorio,
    .bloco-consulta-analise-rastreabilidade,
    .bloco-preenchimento-em-lote,
    .bloco-novos-relatorios-tabela {
        margin-top: 20px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .botao-relatorio__remover,
        .botao-relatorio__salvar {
            margin-top: 16px;
            .lyra-icon.lyra-grafico ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
